import { Spin } from 'antd';

import classes from './SuspenseLoader.module.css';

const SuspenseLoader = () => {
  return (
    <div className={classes.suspenseLoader}>
      <Spin size="large" />
    </div>
  );
};

export default SuspenseLoader;
